const { createSlice } = require("@reduxjs/toolkit");
const token = localStorage.getItem("token");
const initialState = {
  isLoggedIn: !!token,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLoginStatus: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
});

export const { setLoginStatus } = loginSlice.actions;
export const selectLoginStatus = (state) => state.login.isLoggedIn;
export default loginSlice.reducer;
